import { runtimeConfig } from '@/config/runtime';
import { post } from './api';

export type FeedbackValue = 'positive' | 'negative';

export interface FeedbackRequest {
  run_id: string;
  value: FeedbackValue;
}

export interface FeedbackResponse {
  code: string;
  message: string;
}

export const sendAnswerFeedback = (
  runId: string,
  value: FeedbackValue,
): Promise<FeedbackResponse> => post<FeedbackResponse, FeedbackRequest>(
  runtimeConfig.feedbackApiUrl,
  { run_id: runId, value },
);

/** 上游尚未提供取消协议，暂以异步函数保留未来接入点。 */
export const cancelAnswerFeedback = async (): Promise<void> => Promise.resolve();
